import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar, useIonLoading, useIonModal, useIonRouter } from '@ionic/react';
import React, { useState } from 'react';
import "./Modal.css"
import { RouteComponentProps } from 'react-router';
import { Tipo } from '../interfaces';

import dataArtesanias from '../data/artesanias.json'
import CardArtesnia from "./CardArtesnia";

import dataMuseos from '../data/museos_oaxaca.json'
import CardMuseo from "./CardMuseo";

import dataPueblosMagicos from '../data/pueblosmagicos_pos.json'
import CardPuebloMagico from './CardPuebloMagico';
import dataCooperativas from '../data/cooperativas.json'

import dataTours from '../data/tours.json'
import CardTour from './CardTour';

import dataHospedaje from '../data/hospedaje.json'
import CardHospedaje from './CardHospedaje';

import RestaurantCard from '../components/Tab2/RestaurantCard';
import dataRestaurante from '../data/restaurantes.json'

import { arrowBack } from 'ionicons/icons';

import dataArq from '../data/zona-arqueologica-fr.json'
import CardArq from './CardArq';

import dataTurComEsp from '../data/maya-ka-an.json'
import dataTurComMaya from '../data/maya-ka-an-lang-maya.json'
import dataTurComEng from '../data/maya-ka-an-lang-english.json'
import dataTurComFren from '../data/maya-ka-an-lang-french.json'
import dataTurComChin from '../data/maya-ka-an-lang-chinese.json'

import CardTurCom from './CardTurCom';

import dataExpYucatan from '../data/experiencias_f1.json'
import CardExpYucatan from './CardExpYucatan';

import dataSabYucatan from '../data/datasabores_f1.json'
import CardSabYucatan from './CardSabYucatan';

import dataPlatilloQRoo from '../data/data_cocinaqroo.json'
import CardPlatilloQRoo from './CardPlatilloQRoo';

import { useTranslation } from 'react-i18next';
import { MenuSitios } from '../interfaces';

const Modal : React.FC<Tipo> = ({ match }) => {
  const router = useIonRouter();
  const [t,i18n] = useTranslation("global");

  console.log('Language: ',i18n.language);

  const langEnable = i18n.language;

  let dataTurCom = dataTurComMaya;

  switch(langEnable){
      case 'es':
        dataTurCom = dataTurComEsp;
          break;
      case 'en':
        dataTurCom = dataTurComEng;
          break;
      case 'fr':
        dataTurCom = dataTurComFren;
          break;
      case 'zh':
        dataTurCom = dataTurComChin;
          break;
      case 'maya':
        dataTurCom = dataTurComMaya;
          break;
  }

  //let dataTurCom;

    return (
      <React.Suspense>
        <IonPage>
          {(match.params.nom === "arqueologia")?(
            <>
            <IonHeader translucent={true}>
                    <IonToolbar className='Arqueologia header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                              {/* {t("zones-arq.close-btn")} */}
                              <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("zones-arq.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataArq.map(Arq=>
                        <CardArq
                            key={Arq.nombre}
                            nombre={Arq.nombre} 
                            traduccion={Arq.traduccion} 
                            municipio={Arq.municipio} 
                            descripcion={Arq.descripcion} 
                            horario={Arq.horario} 
                            sitio_web={Arq.sitio_web} 
                            precio = {Arq.precio}
                            tipo={Arq.tipo}
                            urlImage={Arq.urlImagen} 
                            promocion={Arq.promocion} 
                        />  
              )}
            </IonContent>
            </>
          ):("")}
          {(match.params.nom === "platillosqroo")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Tours header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                            {/* {t("tours.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>Platillos de la Cocina Quintanaroense</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataPlatilloQRoo.map(platqroo=>
                        <CardPlatilloQRoo
                            key = {platqroo.nombrePlatillo}
                            nombrePlatillo={platqroo.nombrePlatillo}
                            chef={platqroo.chef}
                            localidad={platqroo.localidad}
                            estado={platqroo.estado}
                            latitud={platqroo.latitud}
                            longitud={platqroo.longitud}
                            descripcion={platqroo.descripcion}
                            imagenPlatillo={platqroo.imagenPlatillo}
                            ingredientes={platqroo.ingredientes}
                            imagenesIngredientes={platqroo.imagenesIngredientes}
                            procedimiento={platqroo.procedimiento}
                        />  
              )}
            </IonContent>
          </>
        ):("")}

        {(match.params.nom === "tours")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Tours header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                            {/* {t("tours.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("tours.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataTours.map(tour=>
                        <CardTour
                            key={tour.titulo}
                            estacion={tour.estacion}
                            titulo={tour.titulo}
                            imgPortada={tour.imgPortada}
                            precio={tour.precio}
                            sitioWeb={tour.sitioWeb}
                            actividades={tour.actividades}
                            imgActividades={tour.imgActividades}
                            telefono={tour.telefono}
                            incluye={tour.incluye}
                        />  
              )}
            </IonContent>
          </>
        ):("")}
        {(match.params.nom === "artesanias")?(
          <>
            <IonHeader translucent={true}>
                    <IonToolbar className='Artesanias header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                          {/* {t("artesanias.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("artesanias.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataArtesanias.map(artesania=>
                        <CardArtesnia
                            key={artesania.nombreautor}
                            nombreAutor={artesania.nombreautor}
                            nombrePieza={artesania.nombrepieza}
                            localidad={artesania.localidad}
                            descripcion={artesania.descripcion}
                            historia={artesania.historia}
                            proceso={artesania.procesoproduccion}
                            precio={artesania.precio}
                            urlImg={artesania.urlImagen}
                        />  
              )}
            </IonContent>
          </>
        ):("")}
        {(match.params.nom === "comida")?(
          <>
            <IonHeader translucent={true}>
                      <IonToolbar className='Restaurantes header-titles'>
                        <IonButtons slot='start'>
                            <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                            {/* {t("hostage.close-btn")} */}
                              <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                            </IonButton>
                        </IonButtons>
                        <IonTitle>{t("Tab2.title")}</IonTitle>
                      </IonToolbar>
              </IonHeader>
              <IonContent fullscreen={true}>
                {dataRestaurante.map(restaurante=>
                  <RestaurantCard
                    key = {restaurante.nombre}
                    nombre ={restaurante.nombre}
                    direccion = {restaurante.direccion}
                    imageUrl = {restaurante.urlImagen}
                    calificacion = {restaurante.calificacion}
                    open = {restaurante.horario}
                  />  
                )}
              </IonContent>
          </>
        ):("")}
        {(match.params.nom === "museos")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Museos header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                              {/* {t("zones-arq.close-btn")} */}
                              <IonIcon icon={arrowBack} size='large'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("Museos.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataMuseos.map(Mus=>
                        <CardMuseo
                            key={Mus.nombre}
                            nombre={Mus.nombre} 
                            municipio={Mus.municipio} 
                            descripcion={Mus.descripcion} 
                            horario={Mus.horario} 
                            sitio_web={Mus.sitio_web} 
                            precio = {Mus.precio}
                            tipo={Mus.tipo}
                            urlImagen={Mus.urlImagen} 
                            promocion={Mus.promocion} 
                        />  
              )}
            </IonContent>
          </>
        ):("")}
        {(match.params.nom === "transporte")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Pueblos Mágicos header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                          {/* {t("hostage.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("Pueblos Mágicos")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataPueblosMagicos.map(PMag=>
                        <CardPuebloMagico
                        key={PMag.nombre}
                        nombre={PMag.nombre} 
                        traduccion={PMag.traduccion}
                        municipio={PMag.municipio} 
                        latitud={PMag.latitud}
                        longitud={PMag.longitud}
                        descripcion={PMag.descripcion} 
                        horario={PMag.horario} 
                        sitio_web={PMag.sitio_web} 
                        precio = {PMag.precio}
                        tipo={PMag.tipo}
                        promocion={PMag.promocion} 
                        urlImagen={PMag.urlImagen} 
                        caracteristicas={PMag.caracteristicas}
                        atractivos={PMag.atractivos}
                        festividades={PMag.festividades}
                        ubicacion={PMag.ubicacion}
                    />  
          )}
            </IonContent>

          </>
        ):("")}
        {(match.params.nom === "hospedaje")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Hospedajes header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                          {/* {t("hostage.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("hostage.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataHospedaje.map(hospedaje=>
                        <CardHospedaje
                            key={hospedaje.nombre}
                            nombre={hospedaje.nombre}
                            direccion={hospedaje.direccion}
                            telefono={hospedaje.telefono}
                            urlImage={hospedaje.URLimagen}
                            precio={hospedaje.precio_habitacion_sencilla}
                            resena={hospedaje.resena}
                            calificacion={hospedaje.calificacion}
                            incluye={hospedaje.incluye}
                            imgActividades={hospedaje.imgActividades}
                        />  
              )}
            </IonContent>
          </>
        ):("")}
        {(match.params.nom === "cooperativa")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Cooperativas header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                          {/* {t("hostage.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("Cooperativas")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataCooperativas.map(Mus=>
                        <CardMuseo
                        key={Mus.nombre}
                        nombre={Mus.nombre} 
                        municipio={Mus.municipio} 
                        descripcion={Mus.descripcion} 
                        horario={Mus.horario} 
                        sitio_web={Mus.sitio_web} 
                        precio = {Mus.precio}
                        tipo={Mus.tipo}
                        urlImagen={Mus.urlImagen} 
                        promocion={Mus.promocion} 
                    />  
          )}
            </IonContent>

          </>
        ):("")}
        {(match.params.nom === "turcom")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Cooperativas header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos TurCom");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                          {/* {t("hostage.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("turcom.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataTurCom.map(TurCom=>
                        <CardTurCom
                        key={TurCom.titulo}
                        id={TurCom.id}
                        nombre={TurCom.nombre} 
                        empresa={TurCom.empresa}
                        localidad={TurCom.localidad}
                        estado={TurCom.estado}
                        titulo={TurCom.titulo}
                        programa={TurCom.programa}
                        latitud={TurCom.latitud}
                        longitud={TurCom.longitud}
                        heroImage={TurCom.heroImage}
                        sitioWeb={TurCom.sitioWeb}
                        descripcion={TurCom.descripcion} 
                        actividades={TurCom.actividades} 
                        imagenes={TurCom.imagenes} 
                        datos_contacto = {TurCom.datos_contacto}
                        incluye={TurCom.incluye}
                />  
          )}
            </IonContent>

          </>
        ):("")}
        {(match.params.nom === "expyuc")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Cooperativas header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos TurCom");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                          {/* {t("hostage.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("turcom.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataExpYucatan.map(ExpYucatan=>
                        <CardExpYucatan
                        key={ExpYucatan.nombre}
                        id={ExpYucatan.id}
                        lugar={ExpYucatan.lugar} 
                        nombre={ExpYucatan.nombre}
                        imagen_prin={ExpYucatan.imagen_prin}
                        nombre_corto={ExpYucatan.nombre_corto}
                        informacion={ExpYucatan.informacion}
                        regiones={ExpYucatan.regiones}
                        imagenes={ExpYucatan.imagenes}
                        descripcion={ExpYucatan.descripcion}
                        actividades={ExpYucatan.actividades}
                        distancias={ExpYucatan.distancias}
                        sugerido_para={ExpYucatan.sugerido_para} 
                        latitud={ExpYucatan.latitud} 
                        longitud={ExpYucatan.longitud}
                    />  
              )}
            </IonContent>

          </>
        ):("")}

        {(match.params.nom === "sabyuc")?(
          <>
          <IonHeader translucent={true}>
                    <IonToolbar className='Cooperativas header-titles'>
                      <IonButtons slot='start'>
                          <IonButton onClick={(e) => {
                           e.preventDefault();
                           console.log("Ya nos fuimos TurCom");
                           router.push('/app/tabs/tab1','back');
                        }} color='light'>
                          {/* {t("hostage.close-btn")} */}
                            <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle>{t("turcom.title")}</IonTitle>
                    </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
              {dataSabYucatan.map(SabYucatan=>
                        <CardSabYucatan
                        key={SabYucatan.nombre}
                        id={SabYucatan.id}
                        lugar={SabYucatan.lugar} 
                        nombre={SabYucatan.nombre}
                        imagen_prin={SabYucatan.imagen_prin}
                        nombre_corto={SabYucatan.nombre_corto}
                        informacion={SabYucatan.informacion}
                        regiones={SabYucatan.regiones}
                        imagenes={SabYucatan.imagenes}
                        descripcion={SabYucatan.descripcion}
                        datos_interes={SabYucatan.datos_interes}
                        distancias={SabYucatan.distancias}
                        latitud={SabYucatan.latitud} 
                        longitud={SabYucatan.longitud}
                    />  
              )}
            </IonContent>

          </>
        ):("")}

        </IonPage>
        </React.Suspense>
    );
};

export default Modal;